import { useLayout } from "../contexts/LayoutContext";
import { useLocation } from "react-router-dom";
import { MAIN_MENU } from "../routes/menuConfig";
import "./Footer.scss";

const SIZES = [
  { value: "small", fontSize: 11, title: "Small text" },
  { value: "medium", fontSize: 13, title: "Medium text" },
  { value: "large", fontSize: 16, title: "Large text" },
];

const Footer = () => {
  const { isSmall, uiSize, setUiSize } = useLayout();
  const location = useLocation();

  const activeMenu = MAIN_MENU.find((m) => m.path && location.pathname.startsWith(m.path));

  const sizeButtons = (
    <span className="footer__sizes" role="group" aria-label="Text size">
      {SIZES.map((s) => (
        <button
          key={s.value}
          type="button"
          title={s.title}
          aria-label={s.title}
          aria-pressed={uiSize === s.value}
          className={`footer__size${uiSize === s.value ? " footer__size--active" : ""}`}
          style={{ fontSize: s.fontSize }}
          onClick={() => setUiSize(s.value)}
        >
          A
        </button>
      ))}
    </span>
  );

  if (isSmall) {
    return (
      <footer className="footer footer--small">
        {sizeButtons}
        <span className="footer__copyright">&copy; {new Date().getFullYear()} YourRightHand</span>
      </footer>
    );
  }

  return (
    <footer className="footer">
      <span className="footer__section">{activeMenu?.title || ""}</span>
      {sizeButtons}
      <a className="footer__support" href="mailto:support@yourrighthand.ai">Contact Support</a>
      <span className="footer__copyright">&copy; {new Date().getFullYear()} YourRightHand</span>
    </footer>
  );
};

export default Footer;
